import { Inject, Injectable, InjectionToken } from '@angular/core';
import { initialize, LDClient, LDContext, LDOptions } from 'launchdarkly-js-client-sdk';
import SessionReplay from '@launchdarkly/session-replay';
import { ConnectionService } from '@services/connection-service';
import { AppConfig } from '../../app/app.config';

export type LDInitializeFn = (envKey: string, context: LDContext, options?: LDOptions) => LDClient;

export const LD_INITIALIZE_FN = new InjectionToken<LDInitializeFn>('LD_INITIALIZE_FN', {
  providedIn: 'root',
  factory: () => initialize,
});

@Injectable({ providedIn: 'root' })
export class LaunchDarklyService {
  private client?: LDClient;

  constructor(
    private readonly conn: ConnectionService,
    private readonly appConfig: AppConfig,
    @Inject(LD_INITIALIZE_FN) private readonly ldInitialize: LDInitializeFn,
  ) {}

  init(user: { get(field: string): string | undefined }): void {
    if (!user) return;

    const clientId = this.getClientId();
    if (!clientId) return;

    const context: LDContext = {
      kind: 'user',
      key: user?.get('username'),
    };

    this.client = this.ldInitialize(clientId, context, {
      plugins: [
        new SessionReplay({
          privacySetting: 'default',
          blockClass: 'ld-session-block',
        }),
      ],
    });

    this.client.waitForInitialization().catch(() => {});
  }

  getClientId(): string {
    return this.conn.isDevelopmentEnvironment ?
      this.appConfig.Shared?.LaunchDarkly?.CLIENT_ID_DEV
      : this.appConfig.Shared?.LaunchDarkly?.CLIENT_ID_PROD;
  }
}
